import React from 'react';
import { FormControl, InputLabel, MenuItem, Select, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import InfoIcon from '@material-ui/icons/Info';
import { 
  BOOLEAN_CONDITION_LABEL_NOT_SET, 
  BOOLEAN_CONDITION_LABEL_REQUIRE_FALSE, 
  BOOLEAN_CONDITION_LABEL_REQUIRE_TRUE 
} from 'nba/nba.constants';

interface BooleanConditionProps {
  label: string;
  description?: string;
  value: boolean | undefined;
  onChange: (value: boolean | undefined) => void;
}

const useStyles = makeStyles({
  inlineRow: {
    display: 'flex',
    alignItems: 'center',
  },
  grow: {
    flex: 1,
  },
  infoIcon: {
    marginLeft: 8,
    cursor: 'help',
  },
});

export const BooleanCondition: React.FC<BooleanConditionProps> = ({
  label,
  description,
  value,
  onChange,
}) => {
  const classes = useStyles();
  
  const handleChange = (e: React.ChangeEvent<{ value: unknown }>) => {
    const { value: v } = e.target;
    
    if (v === '') {
      onChange(undefined);
    } else if (v === 'true') {
      onChange(true);
    } else {
      onChange(false);
    }
  };
  
  return (
    <div className={classes.inlineRow}>
      <FormControl
        fullWidth
        className={classes.grow}
        margin="normal"
      >
        <InputLabel>
          {label}
        </InputLabel>
        <Select
          value={value === undefined ? '' : value ? 'true' : 'false'}
          onChange={handleChange}
        >
          <MenuItem value="">
            <em>
              {BOOLEAN_CONDITION_LABEL_NOT_SET}
            </em>
          </MenuItem>
          <MenuItem value="true">
            {BOOLEAN_CONDITION_LABEL_REQUIRE_TRUE}
          </MenuItem>
          <MenuItem value="false">
            {BOOLEAN_CONDITION_LABEL_REQUIRE_FALSE}
          </MenuItem>
        </Select>
      </FormControl>
      {description && (
        <Tooltip title={description}>
          <InfoIcon
            className={classes.infoIcon}
            color="action"
          />
        </Tooltip>
      )}
    </div>
  );
};
